/**
 * Test file for mobile detection functionality
 * This file can be used to test the mobile detection logic
 */

import { isMobileDevice, isTabletDevice, getDeviceType, shouldUseMobileUI } from './mobileDetection';

// Test function to log device detection results
export const testMobileDetection = () => {
  
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    userAgent: navigator.userAgent,
    isMobile: isMobileDevice(),
    isTablet: isTabletDevice(),
    deviceType: getDeviceType(),
    shouldUseMobileUI: shouldUseMobileUI()
  };
};

// Test function to simulate different screen sizes
export const testScreenSizes = () => {
  const testSizes = [
    { width: 320, height: 568, name: 'iPhone 5' },
    { width: 375, height: 667, name: 'iPhone 6/7/8' },
    { width: 414, height: 896, name: 'iPhone 11' },
    { width: 768, height: 1024, name: 'iPad' },
    { width: 1024, height: 768, name: 'iPad Landscape' },
    { width: 1200, height: 800, name: 'Desktop' },
    { width: 1920, height: 1080, name: 'Large Desktop' }
  ];
  
  testSizes.forEach(size => {
    // Mock window dimensions for testing
    const originalInnerWidth = window.innerWidth;
    const originalInnerHeight = window.innerHeight;
    
    // Temporarily change window dimensions
    Object.defineProperty(window, 'innerWidth', {
      writable: true,
      configurable: true,
      value: size.width
    });
    Object.defineProperty(window, 'innerHeight', {
      writable: true,
      configurable: true,
      value: size.height
    });
    
    
    // Restore original dimensions
    Object.defineProperty(window, 'innerWidth', {
      writable: true,
      configurable: true,
      value: originalInnerWidth
    });
    Object.defineProperty(window, 'innerHeight', {
      writable: true,
      configurable: true,
      value: originalInnerHeight
    });
  });
};

// Export test functions for use in browser console
if (typeof window !== 'undefined') {
  window.testMobileDetection = testMobileDetection;
  window.testScreenSizes = testScreenSizes;
}